import {UpdateQueryStrategyFactory} from './query-update.strategy';
import {FrontendUmsatzstatistikQuery} from '../types/frontend-umsatzstatistik.query';

export const hautpgruppeQueryUpdateStrategy: UpdateQueryStrategyFactory<string> = () => {
  return {
    umsatzebene: 'Hauptgruppe',
    updateFn: async (arthauptgrp, query) => {
      query.hauptgruppe = { arthauptgrp } as any;
      return query;
    },
    removeFn: async (query: FrontendUmsatzstatistikQuery)  => {
      delete query['hauptgruppe']
      return query;
    }
  }
}
